import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=34dddd42&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=34dddd42&prod&scoped=true&lang=css&"
import style1 from "./Sections.vue?vue&type=style&index=1&id=34dddd42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dddd42",
  null
  
)

export default component.exports